module.exports = __webpack_public_path__ + "static/img/41.980c866.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/41.jpg
// module id = 0oFI
// module chunks = 0